import React from 'react';

const ZendeskLibraryFilter = props => {
  const { filter } = props.i18n;

  return (
    <div className="ElementLibrary-filter d-f jc-sb f-sh-0">
      <select className="ElementLibrary-dropdown" onChange={props.filterData}>
        <option value="user">{filter.user}</option>
        <option value="company">{filter.company}</option>
      </select>
    </div>
  );
};

export default ZendeskLibraryFilter;
